const customerIoSiteIdMap: Record<string, string | undefined> = {
  vio: process.env.NEXT_PUBLIC_CUSTOMER_IO_VIO_TRACKING_SITE_ID,
  findhotel: process.env.NEXT_PUBLIC_CUSTOMER_IO_VIO_TRACKING_SITE_ID,
  holidaypiratesde:
    process.env.NEXT_PUBLIC_CUSTOMER_IO_HOLIDAYPIRATESDE_TRACKING_SITE_ID
}

export default customerIoSiteIdMap
